import { render, staticRenderFns } from "./registration_excel.html?vue&type=template&id=2345ef42&scoped=true&external"
import script from "./registration_excel.vue?vue&type=script&lang=js"
export * from "./registration_excel.vue?vue&type=script&lang=js"
import style0 from "./registration_excel.vue?vue&type=style&index=0&id=2345ef42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2345ef42",
  null
  
)

export default component.exports